import React, { useState, useEffect } from 'react'

const BackToTopV2 = () => {
    const [showScroll, setShowScroll] = useState(false)

    useEffect(() => {
        const handleScroll = () => {
            setShowScroll(window.pageYOffset > 800)
        }

        window.addEventListener('scroll', handleScroll, { passive: true })
        handleScroll()

        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    const backToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    return (
        <div
            className={`BackToTopV2 ${!showScroll ? 'd-none' : ''}`}
            onClick={backToTop}
        >
            <i className="fa fa-long-arrow-up" />
        </div>
    )
}

export default BackToTopV2
